import { render, staticRenderFns } from "./BoardPanel.vue?vue&type=template&id=2bfa8325"
import script from "./BoardPanel.vue?vue&type=script&lang=js"
export * from "./BoardPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports